export default __webpack_public_path__ + "static/SSSpyView_screenshot-3-a0cb5a95527f4eb489bd1ea903ac709e.jpg";